import React, { ReactNode, useState, useEffect } from 'react';
import _pullAt from 'lodash/pullAt';

import DropzoneCard from './DropzoneCard';


export interface IMediaArrayFields {
  meta?: any;
  placeholder: string | ReactNode;
  filesDefault: any[];
  disabled: boolean;
}

export const MediaArrayField = ({
  meta,
  placeholder,
  disabled,
  filesDefault,
  ...props
}: IMediaArrayFields) => {
  const [files, setFiles] = useState(filesDefault || []);
  const [rejectedFiles, setRejectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const _setRejectedFiles = (rFiles: any) => {
    setRejectedFiles(rFiles);
  };

  const handleDrop = (acceptedFiles: any, _rejectedFiles: any[]) => {
    setLoading(true);
    setFiles([...files, ...acceptedFiles]);
    const rFiles = _rejectedFiles.map((file: { name: any; size: any; }) => ({
      name: file.name,
      size: file.size,
      reason:
        "File is bigger than 10mb so will be ignored, please choose another file or trim"
    }));
    _setRejectedFiles([...rejectedFiles, ...rFiles]);
  };
  const handleRemove = (index: number, isRejected: boolean) => (e: { stopPropagation: () => void; preventDefault: () => void; }) => {
    e.stopPropagation();
    e.preventDefault();
    if (!isRejected) {
      setFiles(files.filter((_, idx: number) => idx !== index))
    } else {
      const _rejectedFiles = [...rejectedFiles];
      _pullAt(_rejectedFiles, index);
      setRejectedFiles(_rejectedFiles);
    }
  };

  useEffect(() => {
    setLoading(false);
  }, [files, rejectedFiles]);

  return (
    <>
      <DropzoneCard
        placeholder={placeholder}
        files={files}
        loading={loading}
        rejectedFiles={rejectedFiles}
        onDrop={handleDrop}
        handleRemove={handleRemove}
        {...props}
      />
    </>
  );
};

MediaArrayField.defaultProps = {
  disabled: false,
  filesDefault: [],
};

export default MediaArrayField;
